import React from 'react';
import styles from './styles.scss';

import { Head as BaseHead } from '@politico/interactive-style';

const Head = props => (
  <BaseHead no-typekit {...props}>
    <link rel='stylesheet' href='https://use.typekit.net/qld1irc.css' />,
    <script>{`try{Typekit.load({ async: true });}catch(e){}`}</script>,
    {props.children}
  </BaseHead>
);

export default Head;
